import { Media } from '@twilio/conversations';
import { useEffect, useState } from 'react';

import { FileContent } from 'src/components/FileContent/FileContent';
import { useElementOnScreen } from 'src/hooks/useElementOnScreen';

import styles from './ChatAttachment.module.scss';

const selector = {
  fileContainer: 'chat-file-contianer',
  fileName: 'chat-file-name',
  fileSize: 'chat-file-size',
};

type Props = {
  file: Media;
};

export function ChatAttachment({ file }: Props) {
  const [fileUrl, setFileUrl] = useState('');
  const { contentType, filename } = file || {};
  const { containerRef, isVisible } = useElementOnScreen<HTMLParagraphElement>({ threshold: 0.5 });

  useEffect(() => {
    const getUrl = async () => {
      const url = await file.getContentTemporaryUrl();

      setFileUrl(url ?? '');
    };

    //only load the file if it is visible otherwise it might flood the network
    if (file && isVisible) {
      getUrl();
    }
  }, [file, isVisible]);

  return (
    <div className={styles.fileContainer} data-cy={selector.fileContainer}>
      <FileContent type={contentType} url={fileUrl} />

      <p ref={containerRef} data-cy={selector.fileName}>
        {filename}
      </p>
    </div>
  );
}
